module.exports = __webpack_public_path__ + "img/favorite_border-24px.c7ecf461.svg";